import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppComponent } from './app.component';

// Modulos
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { ToastrModule } from 'ngx-toastr';
import { ReactiveFormsModule } from '@angular/forms';

// Componentes
import { LoginComponent } from './components/login/login.component';
import { SignInComponent } from './components/sign-in/sign-in.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { SpinnerComponent } from './shared/spinner/spinner.component';
import { AddTokenInterceptor } from './utils/add-token.interceptor';
import { AddEditProductComponent } from './components/add-edit-product/add-edit-product.component';
import { ProgressBarComponent } from './shared/progress-bar/progress-bar.component';
import { StudentComponent } from './components/student/student.component';
import { AddEditStudentComponent } from './components/add-edit-student/add-edit-student.component';
import { AddEditCenterComponent } from './components/add-edit-center/add-edit-center.component';
import { CenterComponent } from './components/center/center.component';
import { AddEditManagmentComponent } from './components/add-edit-managment/add-edit-managment.component';
import { ManagmentComponent } from './components/managment/managment.component';
import { CareerComponent } from './components/career/career.component';
import { AddEditCareerComponent } from './components/add-edit-career/add-edit-career.component';
import { InscriptionComponent } from './components/inscription/inscription.component';
import { AddEditInscriptionComponent } from './components/add-edit-inscription/add-edit-inscription.component';
import { ForgotComponent } from './components/forgot/forgot.component';
import { TurnComponent } from './components/turn/turn.component';
import { AddEditTurnComponent } from './components/add-edit-turn/add-edit-turn.component';
import { AddEditAreaComponent } from './components/add-edit-area/add-edit-area.component';
import { AreaComponent } from './components/area/area.component';
import { AddEditAreaCenterComponent } from './components/add-edit-area-center/add-edit-area-center.component';
import { AreaCenterComponent } from './components/area-center/area-center.component';
import { PracticeComponent } from './components/practice/practice.component';
import { AddEditPracticeComponent } from './components/add-edit-practice/add-edit-practice.component';
import { PracticeinscriptionComponent } from './components/practiceinscription/practiceinscription.component';
import { AddEditPracticeinscriptionComponent } from './components/add-edit-practiceinscription/add-edit-practiceinscription.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    SignInComponent,
    DashboardComponent,
    NavbarComponent,
    SpinnerComponent,
    AddEditProductComponent,
    ProgressBarComponent,
    StudentComponent,
    AddEditStudentComponent,
    AddEditCenterComponent,
    CenterComponent,
    AddEditManagmentComponent,
    ManagmentComponent,
    CareerComponent,
    AddEditCareerComponent,
    InscriptionComponent,
    AddEditInscriptionComponent,
    ForgotComponent,
    TurnComponent,
    AddEditTurnComponent,
    AddEditAreaComponent,
    AreaComponent,
    AddEditAreaCenterComponent,
    AreaCenterComponent,
    PracticeComponent,
    AddEditPracticeComponent,
    PracticeinscriptionComponent,
    AddEditPracticeinscriptionComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ReactiveFormsModule,
    HttpClientModule,
    FormsModule,
    BrowserAnimationsModule, // required animations module
    ToastrModule.forRoot({
      timeOut: 4000,
      positionClass: 'toast-bottom-right',
      preventDuplicates: true,
    }), // ToastrModule added
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AddTokenInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
